import Vue from 'vue';
import Foundation from 'foundation-sites/dist/js/foundation.min'; // due to foundation es6 issues...
import * as setup from './scripts/setup';

/** Import scss modules */
import './scss/master.scss';

/** Import required site components */
import ServicePointSearch from './scripts/components/servicepoints/servicepointsearch';

// Import global mixins
import urlParameters from './scripts/mixins/urlParameters';
Vue.mixin(urlParameters);

setup.initializeFoundation(Foundation);
setup.initializeVue();
setup.initializeVueComponents();